import { IAuthRepository } from './interfaces/IAuthRepository';
import { IReportRepository } from './interfaces/IReportRepository';
import { IZoneRepository } from './interfaces/IZoneRepository';

import { FakeAuthRepository } from './fake/FakeAuthRepository';
import { FakeReportRepository } from './fake/FakeReportRepository';
import { FakeZoneRepository } from './fake/FakeZoneRepository';

import { FirebaseAuthRepository } from './firebase/FirebaseAuthRepository';
import { FirebaseReportRepository } from './firebase/FirebaseReportRepository';
import { FirebaseZoneRepository } from './firebase/FirebaseZoneRepository';

export class RepositoryFactory {
  private static authRepository: IAuthRepository | null = null;
  private static reportRepository: IReportRepository | null = null;
  private static zoneRepository: IZoneRepository | null = null;

  static getAuthRepository(): IAuthRepository {
    if (!this.authRepository) {
      if (import.meta.env.VITE_APP_MODE === 'production') {
        this.authRepository = new FirebaseAuthRepository();
      } else {
        this.authRepository = new FakeAuthRepository();
      }
    }
    return this.authRepository;
  }

  static getReportRepository(): IReportRepository {
    if (!this.reportRepository) {
      if (import.meta.env.VITE_APP_MODE === 'production') {
        this.reportRepository = new FirebaseReportRepository();
      } else {
        this.reportRepository = new FakeReportRepository();
      }
    }
    return this.reportRepository;
  }

  static getZoneRepository(): IZoneRepository {
    if (!this.zoneRepository) {
      if (import.meta.env.VITE_APP_MODE === 'production') {
        this.zoneRepository = new FirebaseZoneRepository();
      } else {
        this.zoneRepository = new FakeZoneRepository();
      }
    }
    return this.zoneRepository;
  }

  // Méthode pour forcer la réinitialisation (utile pour les tests)
  static reset(): void {
    this.authRepository = null;
    this.reportRepository = null;
    this.zoneRepository = null;
  }

  // Getter pour savoir quel mode est actif
  static get isProductionMode(): boolean {
    return import.meta.env.VITE_APP_MODE === 'production';
  }

  static get isLocalMode(): boolean {
    return import.meta.env.VITE_APP_MODE === 'local';
  }

  static get currentMode(): string {
    return import.meta.env.VITE_APP_MODE || 'local';
  }
}